import { GET_TRANSPORT_USERS_LIST, GET_TRANSPORT_USERS_LIST_SUCCESS, GET_TRANSPORT_USERS_LIST_FAILURE } from '../constants/get_transport_users_list.constants';

export const getTransportUsersList = searchText => ({ type: GET_TRANSPORT_USERS_LIST, searchText });
export const getTransportUsersListSuccess = payload => ({ type: GET_TRANSPORT_USERS_LIST_SUCCESS, payload });
export const getTransportUsersListFailure = error => ({ type: GET_TRANSPORT_USERS_LIST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_transport_users_list.actions.js